import { colorPalette } from "../../utils/constants";

export const customStyles = {
  mainBox: {
    background: colorPalette.headerBackground,
    py: 6,
    px: {
      xs: 2,
      sm: 4,
    },
    color: colorPalette.white,
  },
  logoSection: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    mb: 1,
  },
  companyName: {
    color: colorPalette.white,
    fontSize: { xs: 18, md: 20 },
    fontFamily: "'Bebas Neue', sans-serif",
    // fontWeight: 600,
    lineHeight: 1.3,
  },
  description: {
    color: colorPalette.white,
    fontSize: "0.9rem",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 300,
    lineHeight: 1.6,
    opacity: 0.85,
  },
  sectionTitle: {
    color: colorPalette.white,
    fontSize: { xs: "1.1rem", md: "1.2rem" },
    fontFamily: "'Bebas Neue', sans-serif",
    // fontWeight: 600,
    mb: 1,
    letterSpacing: 0.5,
  },
  serviceLink: {
    color: colorPalette.white,
    fontSize: "0.9rem",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 300,
    cursor: "pointer",
    opacity: 0.85,
    transition: "all 0.2s ease",
    "&:hover": {
      opacity: 1,
      paddingLeft: "4px",
      color: "#fff",
    },
  },
  contactItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.5,
  },
  contactIcon: {
    color: colorPalette.white,
    fontSize: "1.2rem",
    mt: 0.3,
    opacity: 0.9,
  },
  contactText: {
    color: colorPalette.white,
    fontSize: "0.9rem",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 300,
    lineHeight: 1.5,
    opacity: 0.85,
  },
  contactLink: {
    color: colorPalette.white,
    fontSize: "0.9rem",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 300,
    textDecoration: "none",
    opacity: 0.85,
    transition: "opacity 0.2s ease",
    "&:hover": {
      opacity: 1,
      textDecoration: "underline",
    },
  },
  hoursItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.5,
  },
  dayText: {
    color: colorPalette.white,
    fontSize: "0.9rem",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 400,
    opacity: 0.85,
  },
  timeText: {
    color: colorPalette.white,
    fontSize: "0.85rem",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 300,
    opacity: 0.75,
  },
  socialIcon: {
    color: colorPalette.white,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      transform: "scale(1.1)",
    },
  },
  divider: {
    borderColor: "rgba(255, 255, 255, 0.2)",
    my: 4,
  },
  bottomBar: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "space-between",
    alignItems: "center",
    gap: 2,
  },
  copyrightText: {
    color: colorPalette.white,
    fontSize: "0.85rem",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 300,
    opacity: 0.75,
    textAlign: { xs: "center", sm: "left" },
  },
  bottomLinks: {
    display: "flex",
    // flexDirection: { xs: "column", sm: "row" },
    alignItems: "center",
  },
  bottomLinkText: {
    color: colorPalette.white,
    fontSize: "0.85rem",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 300,
    opacity: 0.75,
    transition: "opacity 0.2s ease",
    "&:hover": {
      opacity: 1,
    },
  },
  link: {
    textDecoration: "none",
  },
  image: {
    borderRadius: 8,
  },
};
